<it-card teaser="true" shadow="true">
  <div *ngIf="loading">
    <it-progress-bar indeterminate="true" [value]="0" color="primary"></it-progress-bar>
  </div>

  <div *ngIf="!loading && dischargeInfo">
    <dl class="row">
      <ng-container *ngIf="fieldsToShow.includes('presumedDischargeDate')">
        <dt class="col-sm-6">Data di dimissione prevista:</dt>
        <dd class="col-sm-6">
          {{ getDateFromType('DDP')?.date ? (getDateFromType('DDP')?.date | date: 'dd/MM/yyyy') : '(-)' }}
        </dd>
      </ng-container>
      <ng-container *ngIf="fieldsToShow.includes('choosedFacility') && request && request.setting.subSettings[0].code != 'CPD' && request.setting.subSettings[0].code != 'CPDMP'">
        <dt class="col-sm-6">Struttura di destinazione:</dt>
        <dd class="col-sm-6">
          <span *ngIf="request.facility">{{ request.facility.name ? request.facility.name : '(-)' }}</span>
          <span *ngIf="!request.facility">(-)</span>
        </dd>
      </ng-container>

      <ng-container *ngIf="fieldsToShow.includes('facilityRequestDate') && request">
        <dt class="col-sm-6" *ngIf="request && request.setting && request.setting.subSettings[0].code != 'CPD' && request.setting.subSettings[0]?.code != 'CPDMP'">Data richiesta alla struttura:</dt>
        <dt class="col-sm-6" *ngIf="request && request.setting && request.setting.subSettings[0].code == 'CPD' || request.setting.subSettings[0].code == 'CPDMP'">Data richiesta di arruolamento:</dt>
        <dd class="col-sm-6">
          {{ getDateFromType('DPS')?.date ? (getDateFromType('DPS')?.date | date: 'dd/MM/yyyy') : '(-)' }}
        </dd>
      </ng-container>

      <ng-container *ngIf="fieldsToShow.includes('facilityConfirmDate') && request">
        <dt class="col-sm-6" *ngIf="request && request.setting && request.setting.subSettings[0].code != 'CPD' && request.setting.subSettings[0].code != 'CPDMP'">Data confermata dalla struttura:</dt>
        <dt class="col-sm-6" *ngIf="request && request.setting && request.setting.subSettings[0].code == 'CPD' || request.setting.subSettings[0].code == 'CPDMP'">Data confermata di arruolamento:</dt>
        <dd class="col-sm-6">
          {{ getDateFromType('DCS')?.date ? (getDateFromType('DCS')?.date | date: 'dd/MM/yyyy') : '(-)' }}
        </dd>
      </ng-container>
      <ng-container *ngIf="fieldsToShow.includes('choosedFacility')  && request && request.setting.subSettings[0].code != 'CPD' && request.setting.subSettings[0].code != 'CPDMP'">
        <dt class="col-sm-6">Conferma Paziente:</dt>
        <dd class="col-sm-6">
          {{['CST','END','CHI','CP'].includes(request.status.code) && getDateFromType('DCS')?.date ? 'Sì': '(-)' }}
        </dd>
      </ng-container>

      <ng-container *ngIf="fieldsToShow.includes('realDischargeDate')">
        <dt class="col-sm-6">Data e ora di dimissione effettiva:</dt>
        <dd class="col-sm-6">
          {{ getDateFromType('DDE')?.date ? (getDateFromType('DDE')?.date | date: 'dd/MM/yyyy HH:mm') : '(-)' }}
        </dd>
      </ng-container>
    </dl>

  </div>
</it-card>